import React from "react";

const InviteCodeForm = (props) => {
  return (
    <>
      <div className="row">
        <div className="col">
          <p>Enter the invitation code sent to your email.</p>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon1">
                Invite Code
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder=""
              aria-label="Invite Code"
              aria-describedby="basic-addon1"
              onChange={(event) => props.setinviteCode(event.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default InviteCodeForm;
